import logo from "./logo.svg";
import "./App.css";
import Research from "./components/Research";
// added primereact theme
import "primereact/resources/themes/lara-light-indigo/theme.css";
function App() {
  return (
    <div>
      <Research />
    </div>
  );
}

export default App;
